import { createAction, props } from '@ngrx/store';

export const interruptChat = createAction('[AI Chat] Interrupt chat');

export const interruptChatSuccess = createAction(
  '[AI Chat] Interrupt chat success',
  props<{ chatConversationId: string }>(),
);

export const interruptChatFailure = createAction(
  '[AI Chat] Interrupt chat failure',
  props<{ chatConversationId?: string; error: string }>(),
);
